import {
    RefreshPlayerDataState,
    RefreshPlayerActionTypes,
    RefreshPlayerCreateAction,
} from "../../types/auth/refreshPlayerData";

const initialState: RefreshPlayerDataState = {
    refreshPlayerData: null,
    loading: false,
    confirmOTPError: null,
};

export const refreshPlayerReducer = (
    state = initialState,
    action: RefreshPlayerCreateAction,
): RefreshPlayerDataState => {
    switch (action.type) {
        case RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA:
            return { ...state, loading: true, confirmOTPError: null, refreshPlayerData: null };

        case RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA_SUCCESS:
            return { ...state, loading: false, confirmOTPError: null, refreshPlayerData: action.payload };

        case RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA_ERROR:
            return { ...state, loading: false, confirmOTPError: action.payload, refreshPlayerData: null };

        default:
            return state;
    }
};